import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { colors, radii, spacing, typography } from '../../core/theme/tokens';

/** Chip for transactions/accounts hidden from household view. */
export function PersonalOnlyChip() {
  return (
    <View style={styles.chip} accessibilityLabel="Personal — hidden from household">
      <Text style={styles.chipMark}>✓</Text>
      <Text style={styles.chipText}>Personal</Text>
    </View>
  );
}

/** Visible edit affordance for own transactions. */
export function TransactionEditGlyph() {
  return (
    <Text style={styles.editGlyph} accessibilityElementsHidden importantForAccessibility="no">
      ✎
    </Text>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: radii.pill,
    backgroundColor: 'rgba(61, 214, 164, 0.12)',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgba(61, 214, 164, 0.35)',
  },
  chipMark: {
    fontSize: 9,
    fontWeight: '800',
    color: colors.accent,
    lineHeight: 12,
  },
  chipText: {
    ...typography.caption,
    fontSize: 10,
    fontWeight: '700',
    color: colors.accent,
    letterSpacing: 0.2,
  },
  editGlyph: {
    fontSize: 16,
    color: colors.textMuted,
    marginLeft: spacing.xs,
    lineHeight: 20,
  },
});
